import { PatientResponseDto } from "@/data/dto/patient-reponse-dto";
import { PatientTableInfoEntity } from "@/domain/entity/patient/patient-table-info-entity";
import { calculateInternationalAge } from "@/utils/calculate-international-age";
import { getProgressType } from "@/utils/enum/progress-type";
import { assertPatientResponseDto } from "@/utils/validation";

export class PatientInfoMapper {
  static toEntity(patientResponseDto: PatientResponseDto): PatientTableInfoEntity {
    // AST 기반 타입 검증
    assertPatientResponseDto(patientResponseDto);

    const state = patientResponseDto.state;
    const step = patientResponseDto.step;

    const progress =
      step === undefined || step === null || patientResponseDto.adherence === null
        ? null
        : {
            step: step,
            type: getProgressType(state ?? ""),
            adherence: Math.ceil((patientResponseDto.adherence ?? 0) * 100),
          };

    // 생년월일 포맷 변환
    let birthDay: string | null = null;
    if (patientResponseDto.patientBirthDate) {
      birthDay = patientResponseDto.patientBirthDate.replace(/-/g, ".");
    }

    let age = calculateInternationalAge(birthDay) ?? 0;

    let memo = patientResponseDto.memo;
    if (memo === null || memo === undefined || memo.length === 0) {
      memo = "-";
    }

    return {
      patientUuid: patientResponseDto.patientUuid,
      screeningId: patientResponseDto.patientScreeningId,
      patientNumber: patientResponseDto.patientName,
      name: patientResponseDto.patientName,
      gender: patientResponseDto.patientGender as "male" | "female" | null,
      birthDay: {
        date: birthDay ?? "",
        age: age,
      },
      isDeactived: !patientResponseDto.isDeactivated,
      progress: progress,
      memo: memo,
      isAvailableAddPrescription: patientResponseDto.canAddTreatment,
    };
  }
}
